import React from "react";
import PropTypes from "prop-types";

import { OrderObject, CurrentUserObject } from "../Queries/OrderQuery";
import ResendShipmentMenuItem from "./ResendShipmentMenuItem";
import DisabledShipmentsButton from "./DisabledShipmentsButton";

class ShipmentsDropdown extends React.Component {
  state = { 
    isOpen: false,
    resendingShipmentId: null
  };

  render() {
    const { order, showCreateOption, toggleCreateShipmentPopup } = this.props;
    
    return (
      <React.Fragment>
        <a
          onClick={this.toggleOpen}
          className={
            "button button--dropdown" + (this.state.isOpen ? " is-open" : "")
          }
        >
          Shipments
          {this.state.isOpen && (
            <ul className="button__menu">
              {showCreateOption && (
                <li>
                  <span
                    onClick={this.state.resendingShipmentId ? null : toggleCreateShipmentPopup}
                    className={
                      "button__menu__link link-text" + 
                      (this.state.resendingShipmentId ? " disabled" : "")
                    }
                  >
                    Create new shipment
                  </span>
                </li>
              )}

              {order.resendableShipments && order.resendableShipments.map((shipment, index) => (
                <li key={index}>
                  <ResendShipmentMenuItem
                    shipment={shipment}
                    order={order}
                    onResendStart={this.handleResendStart}
                    onResendComplete={this.handleResendComplete}
                    isResending={this.state.resendingShipmentId === shipment.id}
                    isDisabled={this.state.resendingShipmentId !== null && this.state.resendingShipmentId !== shipment.id}
                  />
                </li>
              ))}
            </ul>
          )}
        </a>
      </React.Fragment>
    );
  }

  toggleOpen = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  handleResendStart = (shipmentId) => {
    this.setState({ resendingShipmentId: shipmentId });
  };

  handleResendComplete = () => {
    this.setState({ resendingShipmentId: null });
  };
}

ShipmentsDropdown.propTypes = {
  order: OrderObject.isRequired,
  currentUser: CurrentUserObject.isRequired,
  showCreateOption: PropTypes.bool,
  toggleCreateShipmentPopup: PropTypes.func
};

export default ShipmentsDropdown; 